import {createDefaultZone, ZoneFormValues} from '../../../types';

const zonePresets: Array<Partial<Omit<ZoneFormValues, 'id'>>> = [
  {name: 'אזור', shortName: 'אזור', color: '#7ABAFF'},
  {color: '#F09CFF'},
  {color: '#77DE6A'},
  {color: '#FF9A27'},
  {color: '#FF9FB9'},
];

const buildZones = (presets: Array<Partial<Omit<ZoneFormValues, 'id'>>>) =>
  presets.map(preset => createDefaultZone(preset));

export const getZones = () => buildZones(zonePresets);
